module.exports = __webpack_public_path__ + "img/1480944697.a33b1459.jpg";